import React, { useState } from "react";
import {
  Box,
  Grid,
  Paper,
  TextField,
  MenuItem,
  Typography,
  Button,
  Alert,
} from "@mui/material";

import bannerImage from "../img/aaaservices/robotic-program.jpg";

const courses = [
  "Virtual Robotics - Basic",
  "Virtual Robotics - Advanced",
  "Virtual Robotics - Ultra",
  "Tool & Fixture Design - Basic",
  "Tool & Fixture Design - Advanced",
  "Tool & Fixture Design - Ultra",
  "Digital Factory - Basic",
  "Digital Factory - Advanced",
  "Digital Factory - Ultra",
  "Java Programming",
  "Advanced Java Programming",
  "Java Full Stack",
  "Python Programming",
  "Advanced Python Programming",
  "Python Full Stack",
  "React Development",
  "Flutter Development",
  "Spring Boot & MySQL",
  "HTML, CSS & JavaScript",
];

export default function SubmitEnquiry() {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    date: "",
    course: courses[0],
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!formData.name.trim()) {
      setError("Please enter your name");
      return;
    }

    if (!/^[0-9]{10}$/.test(formData.mobile)) {
      setError("Enter valid 10 digit mobile number");
      return;
    }

    const message = `🎓 New Course Enquiry

👤 Name: ${formData.name}
📱 Mobile: ${formData.mobile}
📧 Email: ${formData.email}
📅 Date: ${formData.date}
📚 Course: ${formData.course}

Sent From Website`;

    const whatsappUrl = `https://api.whatsapp.com/send?phone=918096120173&text=${encodeURIComponent(
      message
    )}`;

    window.location.href = whatsappUrl;
  };

  return (
    <Box
      sx={{
        // minHeight: "100vh",
       
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      
      }}
    >
      <Paper
        elevation={8}
        sx={{
          maxWidth: 1200,
          width: "100%",
          borderRadius: { xs: "12px", md: "16px" },
          overflow: "hidden",
        }}
      >
        <Grid container>
          {/* LEFT IMAGE - Hidden on mobile */}
          <Grid item xs={0} md={5} sx={{ display: { xs: "none", md: "block" } }}>
            <Box
              sx={{
                height: "100%",
                minHeight: { md: 500 },
                backgroundImage: `url(${bannerImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "relative",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  bgcolor: "rgba(0,0,0,0.5)",
                  color: "#fff",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  p: { md: 3 },
                }}
              >
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  sx={{ fontSize: { md: "18px" } }}
                >
                  International Institute Of Automate
                </Typography>

                <Typography
                  sx={{
                    mt: 1.5,
                    fontSize: { md: "13px" },
                    lineHeight: 1.4,
                  }}
                >
                  Join Industry Ready Training Programs and Build Your Career
                  with Expert Mentors.
                </Typography>
              </Box>
            </Box>
          </Grid>

          {/* RIGHT FORM */}
          <Grid item xs={12} md={7}>
            <Box sx={{ p: { xs: 2.5, sm: 3, md: 3.5 } }}>
              <Typography
                variant="h5"
                fontWeight="700"
                color="primary"
                sx={{
                  fontSize: { xs: "20px", sm: "22px", md: "24px" },
                  mb: 0.5,
                }}
              >
                Student Enquiry
              </Typography>

              <Typography
                color="text.secondary"
                sx={{
                  fontSize: { xs: "12px", sm: "13px", md: "14px" },
                  mb: 2.5,
                }}
              >
                Send enquiry directly on WhatsApp
              </Typography>

              {error && (
                <Alert
                  severity="error"
                  sx={{
                    mb: 2,
                    fontSize: { xs: "12px", sm: "13px" },
                    py: 0.8,
                  }}
                >
                  {error}
                </Alert>
              )}

              {success && (
                <Alert
                  severity="success"
                  sx={{
                    mb: 2,
                    fontSize: { xs: "12px", sm: "13px" },
                    py: 0.8,
                  }}
                >
                  {success}
                </Alert>
              )}

              <form onSubmit={handleSubmit}>
                <Grid container spacing={{ xs: 1.5, sm: 2 }}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Full Name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      size="small"
                      placeholder="Enter your full name"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          fontSize: { xs: "13px", sm: "14px" },
                        },
                        "& .MuiInputBase-input::placeholder": {
                          fontSize: { xs: "12px", sm: "13px" },
                          opacity: 0.7,
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Mobile Number"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      size="small"
                      placeholder="10 digit number"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          fontSize: { xs: "13px", sm: "14px" },
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Email"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      size="small"
                      placeholder="your@email.com"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          fontSize: { xs: "13px", sm: "14px" },
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      type="date"
                      name="date"
                      InputLabelProps={{ shrink: true }}
                      value={formData.date}
                      onChange={handleChange}
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          fontSize: { xs: "13px", sm: "14px" },
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      select
                      fullWidth
                      label="Select Course"
                      name="course"
                      value={formData.course}
                      onChange={handleChange}
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          fontSize: { xs: "13px", sm: "14px" },
                        },
                      }}
                    >
                      {courses.map((course) => (
                        <MenuItem key={course} value={course}>
                          <span style={{ fontSize: "13px" }}>{course}</span>
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      sx={{
                        py: { xs: 1, sm: 1.2, md: 1.3 },
                        fontSize: { xs: "13px", sm: "14px", md: "15px" },
                        fontWeight: 600,
                        backgroundColor: "#ff6b00",
                        color: "#fff",
                        textTransform: "none",
                        letterSpacing: "0.3px",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          backgroundColor: "#e65c00",
                          transform: "translateY(-2px)",
                          boxShadow: "0 6px 20px rgba(255, 107, 0, 0.3)",
                        },
                        "&:active": {
                          transform: "translateY(0)",
                        },
                      }}
                    >
                      Send WhatsApp Enquiry
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}